import React, { memo, useEffect, useState } from 'react';
import { Form, Nav, Tab, Button } from 'react-bootstrap';

import { RiSearchLine } from '../../../components/icons';
import TabNav from './TabNav';
import TabContent from './TabContent';
import { isMobile } from 'react-device-detect';
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import queryString from 'query-string';
const SearchResultsCardsArea = ({
  search_results,
  type_array,
  setSearchText,
  searchText,
  onSearchButtonClick,
  inViewSearchBox,
  isScrollUpwards
}) => {
  const [isFixed, setIsFixed] = useState(false);
  const { search } = useLocation();
  const queryParams = queryString.parse(search);
  const [activeKey, setActiveKey] = useState('');
  const [urlParams, setUrlParams] = useSearchParams();
  const handleSelect = (key) => {
    setActiveKey(key);
    setUrlParams({ ...queryParams, active: key });
  };

  const scrollListener = () => {
    console.log('scrolling');
    let supportPageOffset = window.pageXOffset !== undefined;
    let isCSS1Compat = (document.compatMode || '') === 'CSS1Compat';
    let scrollTop = supportPageOffset
      ? window.pageYOffset
      : isCSS1Compat
      ? document.documentElement.scrollTop
      : document.body.scrollTop;
    let headerElement =
      document.querySelector('.clr_v3_Header__nav') ||
      document.querySelector('.mblHeader') ||
      document.querySelector('.deskHeaderTop');
    let scrollHt = headerElement?.clientHeight || 0;

    if (scrollTop >= scrollHt) {
      setIsFixed(true);
    } else {
      setIsFixed(false);
    }
  };
  useEffect(() => {
    console.log('ACTIVE_TAB', queryParams?.active);
    setActiveKey(queryParams?.active ? queryParams?.active : 'all');
    isMobile && document.addEventListener('scroll', scrollListener);
    return () => {
      isMobile && document.removeEventListener('scroll', scrollListener);
    };
  }, []);

  return (
    search_results?.length > 0 && (
      <div className="w-100 searchTabSection">
        <Tab.Container activeKey={activeKey} onSelect={handleSelect}>
          <div
            className={`bg-white shadow rounded-3 mb-3 mb-md-4 mb-lg-5 searchTabs position-sticky p-3 p-md-4 ${
              isFixed ? 'tabFixedTop pt-20 pt-md-0' : ''
            }`}
          >
            {!inViewSearchBox && isScrollUpwards && isMobile && (
              <div className="mb-4">
                <div className={'searchForm position-relative open'}>
                  <div className="d-flex justify-content-between">
                    <Form.Control
                      className="fs-16 fw-medium text-dark rounded-3 shadow me-3 me-md-4 px-4 border-0 flex-1 gtm_cl_searchResult_searchResultsCardsArea_search_here"
                      type="text"
                      placeholder="Search here"
                      value={searchText}
                      onChange={setSearchText}
                      onKeyPress={(e) => {
                        if (e.key == 'Enter') {
                          onSearchButtonClick(searchText);
                        }
                      }}
                    />
                    <Button
                      variant="primary"
                      type="button"
                      className="btn btn-primary rounded-3 p-4 searchBtn d-flex justify-content-center align-items-center gtm_cl_searchResult_searchResultsCardsArea_search_here"
                      onClick={() => {
                        onSearchButtonClick(searchText);
                      }}
                    >
                      <RiSearchLine
                        customClass={
                          'text-white fs-36 searchResult_searchResultsCardsArea_search_here_button_icon'
                        }
                        gtmTagVariable="gtm_cl_searchResult_searchResultsCardsArea_search_here"
                      />
                    </Button>
                  </div>
                </div>
              </div>
            )}
            <TabNav type_array={type_array} search_results={search_results} key={activeKey} />
          </div>
          {console.log('test 123', type_array, search_results, activeKey)}
          <TabContent type_array={type_array} search_results={search_results} key={activeKey} />
        </Tab.Container>
      </div>
    )
  );
};

export default memo(SearchResultsCardsArea);
